// extracted by mini-css-extract-plugin
export default {"title":"I47Rd","content":"L9J4k","link":"GHGSj","subContainer":"bjvPR","container":"Kk4pV","warningIcon":"lPOe3","warningText":"xrsEn"};